import { render, staticRenderFns } from "./result-content.vue?vue&type=template&id=0de9b206&scoped=true"
import script from "./result-content.vue?vue&type=script&lang=js"
export * from "./result-content.vue?vue&type=script&lang=js"
import style0 from "./result-content.vue?vue&type=style&index=0&id=0de9b206&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de9b206",
  null
  
)

export default component.exports